function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-tree/~/@babel/runtime/helpers/iterableToArray.js
// module id = 795
// module chunks = 0